import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { orpc } from "@/client";

export function useResolveDivergence() {
	const queryClient = useQueryClient();

	const { mutate, isPending } = useMutation(
		orpc.people.resolveDivergence.mutationOptions({
			onError: () => {
				toast.error("Não foi possível resolver a divergência");
			},
			onSettled: () => {
				queryClient.invalidateQueries({ queryKey: orpc.people.review.key() });
				queryClient.invalidateQueries({ queryKey: orpc.people.detail.key() });
			},
		}),
	);

	return { resolve: mutate, isPending };
}
